module.exports = __webpack_public_path__ + "static/media/image8.f185f733.png";